<template>
  <div class="website-content">
    <div class="fix-box">
      <div class="header">
        <div class="header-l">
          <img src="../../assets/logo.png" alt="">
        </div>
        <div class="header-r">
          <div :class="active === 0 && 'active'">首页</div>
          <div :class="active === 1 && 'active'" @click="handleClick">联系反馈</div>
          <div class="b-active" :style="{'left': active === 1 ? '116px' : '-8px'}"></div>
        </div>
      </div>
    </div>
    <div class="main">
      <WebisteHome />
    </div>
  </div>
</template>

<script>
import WebisteHome from './webisteHome.vue'
export default {
  name: "Website",
  components: {
    WebisteHome,
  },
  data() {
    return {
      active: 0
    };
  },
  computed: {
    
  },
  created() {
    
  },
  methods: {
    handleClick() {
      location.href = this.$BASE_URL + '/feedBack'
    }
  },
};
</script>

<style lang="less" scoped>
.website-content {
  .fix-box {
    width: 100%;
    min-width: 1920px;
    position: fixed;
    top: 0;
    background-color: #fff;
    border-bottom: 1px solid #D8D8D8;
    z-index: 1;
  }
  .header {
    width: 1398px;
    margin: 0 auto;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    .header-l {
      width: 196px;
      height: 54px;
      img {
        cursor: default;
      }
    }
    .header-r {
      position: relative;
      min-width: 178px;
      display: flex;
      div {
        font-weight: 700;
        cursor: pointer;
        &:first-child {
          margin-right: 70px;
        }
        &:hover, &.active {
          color: #507AFC;
        }
      }
      .b-active {
        position: absolute;
        left: -8px;
        bottom: -29px;
        width: 54px;
        height: 5px;
        background: #507AFC;
        border-radius: 2px;
      }
    }
  }
  .main {
    margin-top: 80px;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    overflow-x: hidden;
    min-width: 1920px;
    // 隐藏滚动条
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // ie 10+
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
